module.exports = __webpack_public_path__ + "static/media/Ellipse.fdd57c84.svg";